import { useMemo } from "react";
import { ISSUE_COLUMN_KEYS } from "../../IssuesTab/IssueLog/IssueTable/columnKeys";
import { useAllColumnDefinitions } from "../../IssuesTab/IssueLog/IssueTable/useAllColumnDefinitions";

export default function useTableColumns() {
  const allColumns = useAllColumnDefinitions();

  return useMemo(() => {
    const selectedColumnIds = [
      "select",
      ISSUE_COLUMN_KEYS.ID,
      ISSUE_COLUMN_KEYS.TITLE,
      ISSUE_COLUMN_KEYS.STATUS,
      ISSUE_COLUMN_KEYS.ISSUE_TYPE,
      ISSUE_COLUMN_KEYS.ASSIGNED_TO,
      ISSUE_COLUMN_KEYS.DUE_DATE,
      ISSUE_COLUMN_KEYS.PLACEMENT,
    ];

    return allColumns.filter(
      column => column.id && selectedColumnIds.includes(column.id)
    );
  }, [allColumns]);
}
